
































































import { Component, Vue } from "vue-property-decorator";
import { UserLoginDTO } from "../api/authentication/authentication.model";
import { authenticationStore } from "../api/authentication/authentication.module";

@Component
export default class Login extends Vue {
  payload: UserLoginDTO = {
    identifier: "",
    password: ""
  };
  isLoading: boolean = false;

  async created() {
    // await this.loadDependencyJS([
    //   '/assets/plugins/p-scroll/perfect-scrollbar.js',
    //   '/assets/plugins/p-scroll/pscroll.js',
    //   '/assets/plugins/p-scroll/pscroll-1.js',
    // ]);
    this.loadJs();
  }

  async handle(payload: UserLoginDTO) {
    try {
      await this.validate();
      this.isLoading = true;
      await authenticationStore.Login(payload);
      this.$router.push("/app");
      this.toastSuccess("Login Success");
    } catch (error) {
      if ((error as any)?.response?.status == 400) {
        const hash = this.makeOTPScreenPayload({
          identifiers: [payload.identifier],
          init: true,
          verifyAccount: true,
          routeName: "MainApp"
        });
        return this.$router.push({ name: "OTPScreen", params: { hash } });
      }

      this.handleError(error);
    } finally {
      this.isLoading = false;
    }
  }
}
